/* eslint-disable no-restricted-globals, no-undef, func-names, no-alert */
import './Frontend.scss';

// Set up the event listeners for the PDF button.
document.addEventListener('DOMContentLoaded', () => {
	// Grab our potential PDF link we've added to the page.
	const printLink = document.getElementById('dr-workflow-pdf-generate-link');

	// Hide the button when print is called.
	printLink?.addEventListener('click', event => {
		event.preventDefault();
		window.print();
	}, false);
}, false);

// Handle our force PDF, which needs to be separate from above.
document.addEventListener('DOMContentLoaded', () => {
	// Get the actual page, the PDF link and the div around it.
	const bodyBuild = document.getElementsByTagName('body')[0];

	// If we have the class, continue.
	if ( bodyBuild.classList.contains('dr-workflow-force-print') ) {

		// Trigger the force print.
		window.print();

		// Now get the current URL.
		const currentLink = new URL(window.location.href);

		// Check for the force print flag.
		const forcePrint = currentLink.searchParams.get('dr-force-print');

		// Do we have it?
		if (forcePrint) {
			// Remove the query string parameter from the URL.
			currentLink.searchParams.delete('dr-force-print');

			// Update the browser URL in the event of manual refresh.
			history.replaceState(history.state, '', currentLink.href);
		}
	}
}, false);
